import WarpElement from '@warp-ds/elements-core';
import { customElement, state } from 'lit/decorators.js';
import { Phone } from '../../server/types.js';
import { css, html } from 'lit';
import {
	trackHomepage,
	trackMoreAdsFrom,
	trackPhone,
	trackShowPhone,
} from '../utils/pulseTrackingUtils.js';
import { formatUrl } from '../utils/format.js';
import '@warp-ds/elements/components/button';
import { i18n } from '@lingui/core';

@customElement('org-links')
export class OrgLinks extends WarpElement {
	@state()
	private _phoneNumberIsHidden = true;

	static styles = [
		...WarpElement.styles,
		css`
			@css-placeholder-iB0j0A;
		`,
	];

	adId!: string;
	orgName!: string;
	moreFromUrl?: string;
	phone?: Phone[];
	homepageUrl?: string;
	static properties = {
		adId: { type: String },
		orgName: { type: String },
		moreFromUrl: { type: String },
		phone: { type: Array },
		homepageUrl: { type: String },
	};

	moreFromLink = () =>
		this.moreFromUrl &&
		html`
			<a
				href="${this.moreFromUrl}"
				@click="${() => trackMoreAdsFrom(this.moreFromUrl, this.orgName)}"
			>
				${i18n.t({
					id: 'other.ads',
					message: "The dealer's other ads",
				})}
			</a>
		`;

	phoneNumber = () => {
		if (this.phone?.length) {
			return this._phoneNumberIsHidden
				? html`
						<w-button
							class="block"
							variant="link"
							@click="${() => {
								trackShowPhone(this.orgName);
								this._phoneNumberIsHidden = false;
							}}"
						>
							${i18n.t({
								id: 'show.phone.number',
								message: 'Show phone number',
							})}
						</w-button>
					`
				: this.phone.map(
						(phone) => html`
							<a
								href="${phone.phoneAsLink}"
								@click="${() => trackPhone(this.adId, this.orgName)}"
							>
								${phone.phoneFormatted}
							</a>
						`,
					);
		}
	};

	homepage = () =>
		this.homepageUrl &&
		html`
			<a
				href="${formatUrl(this.homepageUrl)}"
				target="_blank"
				rel="noopener noreferrer"
				@click="${() => trackHomepage(this.orgName, this.homepageUrl)}"
			>
				${i18n.t({
					id: 'website',
					message: 'Website',
				})}
			</a>
		`;

	render() {
		return html`
			<div class="flex flex-col space-y-6 mt-20">
				${this.moreFromLink()} ${this.phoneNumber()} ${this.homepage()}
			</div>
		`;
	}
}
